import App from './App'
import {
	createSSRApp
} from 'vue'
const app = createSSRApp(App)
// app.component('TodoDeleteButton', Tabbar)

/**
 *  @/common/store:初始化store 
 *     --$store里的属性 全局挂载
 *     --$store里的属性 挂载到uni变量
 *  @/common/config.js: 基本配置  
 *    --$config里的属性挂载到全局
 *    --$config里的属性挂载到到uni
 *  @/common/utils/tool.js: 工具方法
 *     --$tools里的属性 全局挂载
 *     --$tools 挂载到uni变量
 * ===================================================================================================
 *  @/common/types: ts定义uview接口 和文件路径
 *  @/common/utils/http.interceptor: 接口拦截
 *  @/common/router/createRouterFile(在vite.config.js引入): 根据pages.json-->tabbar字段 动态生成 common/router 
 *  @/common/index.js: 入口文件
 **/
// 入口文件
import common from '@/common/index.js';
import './common/base/ddlogin.js'
common.initUse(app)
export function createApp() {
	return {
		app,
	}
}